function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div 
        className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"
        role="status"
        aria-label="Memuat"
      >
        <span className="sr-only">Memuat...</span>
      </div>
    </div>
  )
}

export default LoadingSpinner
